export { ParallaxStory } from './ParallaxStory';
